<template>
    <van-popup class="rd-dialog rd-ios-guide" v-model="show" round position="center" @click-overlay="close">
        <div class="content">
            <div class="header">
                <div>{{ $t('pwaGuide.homeScreen') }}</div>
            </div>
            <video class="video_box" controls autoplay playsinline loop>
                <source type="video/mp4" src="@/assets/downApp/iosPwaTips.mp4">
            </video>
            <div class="desc-box">
                <p class="tips-text">{{ $t('displayUi.iosIntro') }}</p>
                <p class="step-text"><span class="dot">1</span>{{ $t('pwaGuide.iosStep1') }}</p>
                <p class="step-text"><span class="dot">2</span>{{ $t('displayUi.iosMore') }}</p>
                <p class="step-text"><span class="dot">3</span>{{ $t('pwaGuide.iosStep2') }}</p>
            </div>
        </div>
        <div class="close-icon">
            <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
        </div>
    </van-popup>
</template>

<script>
export default {
    data() {
        return {
            show: false
        }
    },
    props: {
        isToHome: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        open() {
            this.show = true
        },
        close() {
            this.show = false
            this.toHome()
        },
        toHome() {
            if (!this.isToHome) return
            this.onPageRefresh()
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.van-popup {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
}

.content {
    box-sizing: border-box;
    border: .01rem solid transparent;
    background-image:
        linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
        linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: var(--theme-popup-box-shadow);
    width: 94%;
    max-width: 500px;
    // height: 700px;
    border-radius: .24rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .header {
        display: flex;
        height: .98rem;
        // padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .34rem;

        &>div:first-child {
            font-weight: bold;
            color: $font-color;
        }
    }

    .video_box {
        width: 100%;
        height: 3rem;
        border-radius: .24rem;
        overflow: hidden;
    }

    .desc-box{
        margin: .24rem;
        background: var(--theme-popup-panel-bg);
        box-shadow: inset 8px 8px 30px 0px rgba(255,255,255,0.2), inset -8px -8px 30px 0px rgba(255,255,255,0.2);
        border-radius: 20px 20px 20px 20px;
        padding: .2rem;
    }

    .tips-text {
        color: $font-component-info-strong-color;
        line-height: 1.5;
        font-size: .24rem;
        text-align: left;
        margin-top: .2rem;
    }

    .step-text {
        justify-content: flex-start;
        margin: .2rem auto;
        font-weight: 500;
        line-height: 1.5;
        font-size: .24rem;
        display: flex;
        align-items: center;
        color: $font-color;
        text-align: left;
        margin: .1rem 0;

        .dot {
            width: .4rem;
            height: .4rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100%;
            background: rgba(255, 255, 255, 0.20);
            margin-right: .15rem;
            color: $font-color;
            position: relative;
            overflow: hidden;
            transition: all .3s ease;
            font-size: .26rem;
        }
    }
}

.close-icon {
    // position: absolute;
    background: var(--theme-popup-close-bg);
    border: .01rem solid #3B1C5B;
    width: .68rem;
    height: .68rem;
    // top: 0;
    // right: -.88rem;
    border-radius: .12rem;
    align-items: center;
    justify-content: center;
    font-size: .34rem;
    display: flex;
    cursor: pointer;
    margin-top: .2rem;

    i{
        color: var(--theme-bright-text);
        font-size: .32rem;
    }
}</style>
